// ============================================================
// MOCK DATA — Inspecar (sementara, akan diganti API backend)
// ============================================================

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnNwZWN0b3IlMjBtZWNoYW5pY3xlbnwwfHx8fDE3ODk0NjE3MDl8MA&ixlib=rb-4.1.0&q=85",
  heroAlt: "https://images.unsplash.com/photo-1504222490345-c075b6008014?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxjYXIlMjBpbnNwZWN0b3IlMjBtZWNoYW5pY3xlbnwwfHx8fDE3ODk0NjE3MDl8MA&ixlib=rb-4.1.0&q=85",
  mobilBekas: "https://images.unsplash.com/photo-1684849311607-ad25cec710a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHx3aGl0ZSUyMFNVVnxlbnwwfHx8fDE3ODk0NjE3MDl8MA&ixlib=rb-4.1.0&q=85",
  mobilListrik: "https://images.unsplash.com/photo-1623869675781-80aa31012a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHNlZGFufGVufDB8fHx8MTc4OTQ2MTcyMnww&ixlib=rb-4.1.0&q=85",
  truk: "https://images.unsplash.com/photo-1761141704985-6d060c07f5c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxib3glMjB0cnVja3xlbnwwfHx8fDE3ODk0NjE3MDl8MA&ixlib=rb-4.1.0&q=85",
  moge: "https://images.unsplash.com/photo-1609630875171-b1321377ee65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzcG9ydCUyMG1vdG9yY3ljbGV8ZW58MHx8fDE3ODk0NjE3MTV8MA&ixlib=rb-4.1.0&q=85",
  ctaCouple: "https://images.unsplash.com/photo-1631507091000-b605d38a3c8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxhc2lhbiUyMGNvdXBsZSUyMGNhcnxlbnwwfHx8fDE3ODk0NjE3MTV8MA&ixlib=rb-4.1.0&q=85",
  promoCar: "https://images.unsplash.com/photo-1672386069750-ac577afd9356?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHx3aGl0ZSUyMGNhciUyMHJvYWR8ZW58MHx8fDE3ODk0NjE3MTV8MA&ixlib=rb-4.1.0&q=85",
};

export const AVATARS = {
  andi: "https://images.unsplash.com/photo-1720501828093-c792c10e3f0b?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  budi: "https://images.unsplash.com/photo-1544168190-79c17527004f?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  rizky: "https://images.unsplash.com/photo-1543132220-3ec99c6094dc?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  dimas: "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  sinta: "https://randomuser.me/api/portraits/women/44.jpg",
  rudi: "https://randomuser.me/api/portraits/men/32.jpg",
  userBudi: "https://randomuser.me/api/portraits/men/75.jpg",
  dimasSby: "https://randomuser.me/api/portraits/men/41.jpg",
};

// ---------- LANDING ----------
export const vehicleTypes = [
  { id: "bekas", label: "Mobil Bekas", desc: "Inspeksi menyeluruh sebelum beli", img: IMAGES.mobilBekas },
  { id: "listrik", label: "Mobil Listrik", desc: "Cek baterai, sistem kelistrikan dan performa", img: IMAGES.mobilListrik },
  { id: "truk", label: "Truk", desc: "Untuk kebutuhan bisnis yang lebih aman", img: IMAGES.truk },
  { id: "moge", label: "Motor Moge", desc: "Inspeksi detail untuk motor premium", img: IMAGES.moge },
];

export const howItWorks = [
  { step: 1, title: "Pilih Jenis Kendaraan", desc: "Tentukan jenis kendaraan dan lokasi inspeksi." },
  { step: 2, title: "Pilih Inspector", desc: "Lihat profil, rating, harga, dan jadwal yang tersedia." },
  { step: 3, title: "Booking & Bayar", desc: "Pesan jadwal dan lakukan pembayaran (escrow)." },
  { step: 4, title: "Inspeksi & Laporan", desc: "Inspector datang, isi checklist dan submit laporan." },
  { step: 5, title: "Selesai & Rating", desc: "Review laporan, dana diteruskan ke inspector, dan berikan rating." },
];

export const landingStats = [
  { value: "5.000+", label: "Pengguna Terdaftar" },
  { value: "1.200+", label: "Inspector Profesional" },
  { value: "10.000+", label: "Laporan Inspeksi" },
  { value: "4.9/5", label: "Rating Pengguna" },
];

export const testimonials = [
  { name: "Rudi, Jakarta", avatar: AVATARS.rudi, text: "Laporannya sangat detail dan membantu saya negosiasi harga. Sangat rekomendasi!" },
  { name: "Sinta, Bandung", avatar: AVATARS.sinta, text: "Inspector datang tepat waktu dan sangat profesional. Prosesnya mudah dan aman." },
  { name: "Dimas, Surabaya", avatar: AVATARS.dimasSby, text: "Berkat Inspecar, saya terhindar dari mobil bekas dengan masalah besar. Recommended!" },
];

export const trustBadges = [
  { title: "Inspector", sub: "Terverifikasi" },
  { title: "Laporan Detail", sub: "dan Objektif" },
  { title: "Pembayaran Aman", sub: "(Escrow)" },
  { title: "Tersedia di", sub: "Banyak Kota" },
];

// ---------- STATUS STYLE MAP ----------
export const statusStyles = {
  "Menunggu Konfirmasi": "bg-amber-50 text-amber-600 border border-amber-200",
  "Dijadwalkan": "bg-blue-50 text-blue-600 border border-blue-200",
  "Sedang Inspeksi": "bg-violet-50 text-violet-600 border border-violet-200",
  "Menunggu Bayar": "bg-amber-50 text-amber-600 border border-amber-200",
  "Selesai": "bg-emerald-50 text-emerald-600 border border-emerald-200",
  "Dibatalkan": "bg-red-50 text-red-500 border border-red-200",
};

// ---------- DASHBOARD INSPECTOR ----------
export const inspectorStats = [
  { label: "Pesanan Baru", value: 3, icon: "inbox", color: "text-blue-600 bg-blue-50" },
  { label: "Menunggu Jadwal", value: 5, icon: "calendar", color: "text-amber-600 bg-amber-50" },
  { label: "Sedang Berlangsung", value: 2, icon: "loader", color: "text-violet-600 bg-violet-50" },
  { label: "Selesai", value: 28, icon: "check", color: "text-emerald-600 bg-emerald-50" },
];

export const earningsMonthly = [
  { bulan: "Feb", total: 8 }, { bulan: "Mar", total: 11 }, { bulan: "Apr", total: 14 },
  { bulan: "Mei", total: 17 }, { bulan: "Jun", total: 21 }, { bulan: "Sep", total: 24 },
];

export const ratingBreakdown = [
  { star: 5, count: 78 }, { star: 4, count: 12 }, { star: 3, count: 4 },
  { star: 2, count: 1 }, { star: 1, count: 1 },
];

export const inspectorOrders = [
  { id: "#1234", tanggal: "20 Sep 2026", jenis: "Mobil Bekas", lokasi: "Jakarta Selatan", status: "Menunggu Konfirmasi" },
  { id: "#1233", tanggal: "19 Sep 2026", jenis: "Mobil Listrik", lokasi: "Tangerang", status: "Dijadwalkan" },
  { id: "#1232", tanggal: "18 Sep 2026", jenis: "Truk", lokasi: "Bekasi", status: "Sedang Inspeksi" },
  { id: "#1231", tanggal: "17 Sep 2026", jenis: "Motor Moge", lokasi: "Jakarta Barat", status: "Selesai" },
];

export const todaySchedule = [
  { jam: "09:00", jenis: "Mobil Bekas", lokasi: "Jakarta Selatan" },
  { jam: "13:00", jenis: "Mobil Listrik", lokasi: "Tangerang" },
  { jam: "16:00", jenis: "Motor Moge", lokasi: "Jakarta Barat" },
];

// ---------- DASHBOARD USER ----------
export const userStats = [
  { label: "Total Pesanan", value: 8, icon: "clipboard", color: "text-blue-600 bg-blue-50" },
  { label: "Sedang Berlangsung", value: 2, icon: "loader", color: "text-violet-600 bg-violet-50" },
  { label: "Selesai", value: 5, icon: "check", color: "text-emerald-600 bg-emerald-50" },
  { label: "Dibatalkan", value: 1, icon: "x", color: "text-red-500 bg-red-50" },
];

export const userOrders = [
  { id: "#1234", tanggal: "20 Sep 2026", jenis: "Mobil Bekas", status: "Sedang Inspeksi" },
  { id: "#1233", tanggal: "15 Sep 2026", jenis: "Mobil Listrik", status: "Selesai" },
  { id: "#1232", tanggal: "10 Sep 2026", jenis: "Truk", status: "Selesai" },
  { id: "#1231", tanggal: "5 Sep 2026", jenis: "Motor Moge", status: "Dibatalkan" },
];

export const favoriteInspectors = [
  { name: "Andi Pratama", rating: 4.9, ulasan: 128, lokasi: "Jakarta Selatan", avatar: AVATARS.andi },
  { name: "Budi Santoso", rating: 4.8, ulasan: 96, lokasi: "Jakarta Barat", avatar: AVATARS.budi },
  { name: "Rizky Maulana", rating: 4.7, ulasan: 74, lokasi: "Tangerang", avatar: AVATARS.rizky },
];

export const whyInspecar = [
  { title: "Inspector", sub: "Terverifikasi" },
  { title: "Laporan Detail", sub: "& Objektif" },
  { title: "Pembayaran Aman", sub: "(Escrow)" },
  { title: "Tersedia di", sub: "Banyak Kota" },
];

// ---------- DASHBOARD SUPER ADMIN ----------
export const adminStats = [
  { label: "Total Pengguna", value: "5.234", delta: "+12%", icon: "users", color: "text-blue-600 bg-blue-50" },
  { label: "Total Inspector", value: "1.208", delta: "+8%", icon: "usercheck", color: "text-red-500 bg-red-50" },
  { label: "Total Pesanan", value: "3.892", delta: "+15%", icon: "clipboard", color: "text-emerald-600 bg-emerald-50" },
  { label: "Total Transaksi", value: "Rp 1,24 M", delta: "+18%", icon: "wallet", color: "text-amber-600 bg-amber-50" },
  { label: "Pendapatan Platform", value: "Rp 186,2 Jt", delta: "+20%", icon: "coins", color: "text-emerald-600 bg-emerald-50" },
  { label: "Inspector Menunggu Verifikasi", value: "24", delta: null, icon: "bell", color: "text-amber-600 bg-amber-50" },
];

const days = ["1 Sep","5 Sep","10 Sep","15 Sep","20 Sep","25 Sep","30 Sep"];
export const orderChartData = days.map((d, i) => ({
  hari: d,
  "Mobil Bekas": [120, 150, 165, 140, 190, 170, 210][i],
  "Mobil Listrik": [60, 75, 70, 95, 110, 90, 120][i],
  "Truk": [40, 55, 48, 60, 58, 75, 70][i],
  "Motor Moge": [25, 30, 45, 38, 50, 44, 60][i],
}));

export const adminRecentOrders = [
  { id: "#1234", tanggal: "20 Sep", jenis: "Mobil Bekas", user: "Budi Setiawan", inspector: "Andi Pratama", status: "Sedang Inspeksi" },
  { id: "#1233", tanggal: "19 Sep", jenis: "Mobil Listrik", user: "Sari Dewi", inspector: "Budi Santoso", status: "Selesai" },
  { id: "#1232", tanggal: "18 Sep", jenis: "Truk", user: "PT Logistik Jaya", inspector: "Rizky Maulana", status: "Menunggu Bayar" },
  { id: "#1231", tanggal: "17 Sep", jenis: "Motor Moge", user: "Andika Putra", inspector: "Dimas Arifin", status: "Dibatalkan" },
  { id: "#1230", tanggal: "17 Sep", jenis: "Mobil Bekas", user: "Rina Marlina", inspector: "Andi Pratama", status: "Selesai" },
];

export const regionSpread = [
  { wilayah: "Jakarta", jumlah: 320 },
  { wilayah: "Jawa Barat", jumlah: 210 },
  { wilayah: "Jawa Timur", jumlah: 180 },
  { wilayah: "Jawa Tengah", jumlah: 120 },
  { wilayah: "Banten", jumlah: 90 },
  { wilayah: "Lainnya", jumlah: 288 },
];

export const adminActivities = [
  { icon: "usercheck", color: "text-blue-600 bg-blue-50", title: "Inspector baru mendaftar", desc: "Dimas Arifin", time: "5 menit yang lalu" },
  { icon: "clipboard", color: "text-amber-600 bg-amber-50", title: "Pesanan baru", desc: "#1235 - Mobil Listrik", time: "12 menit yang lalu" },
  { icon: "file", color: "text-blue-600 bg-blue-50", title: "Laporan selesai", desc: "#1234 - Mobil Bekas", time: "28 menit yang lalu" },
  { icon: "banknote", color: "text-emerald-600 bg-emerald-50", title: "Pencairan dana", desc: "Andi Pratama - Rp 450.000", time: "1 jam yang lalu" },
  { icon: "users", color: "text-violet-600 bg-violet-50", title: "User baru mendaftar", desc: "Rina Marlina", time: "2 jam yang lalu" },
];

export const locations = ["Jakarta", "Jakarta Selatan", "Jakarta Barat", "Tangerang", "Bekasi", "Depok", "Bandung", "Surabaya"];
